import React from 'react';
import cx from 'classnames';
import { UserGroupMember } from './UserGroupMember';
import styles from './UserGroupMembers.module.scss';

function MemberGroup({ group, showRole = true, onEditMember }) {
  return (
    <div className={styles['member-group']}>
      {showRole && (
        <div
          className={cx(
            styles['member-group-cohort'],
            group.className,
            'text-only'
          )}
        >
          {group.name}
        </div>
      )}
      <div className={styles['member-list']}>
        {group.members.map((member) => (
          <UserGroupMember
            key={member.user_group_member_id}
            member={member}
            cohortClassName={group.className}
            onEditMember={onEditMember}
          />
        ))}
      </div>
    </div>
  );
}

export default MemberGroup;
